<template>
  <a-spin :spinning="formOption.busy">
    <div >
      <a-form style="padding: 0 15px;" :form="form" :label-col="{ span: 5 }" :wrapper-col="{ span: 7 }"
              @submit="handleSubmit" point-events="false">
        <div class="info_box" @click="fold" v-html="have===1 ? '▶ 保有客户档案详情' : '▼ 保有客户档案详情'"></div>


        <a-tabs default-active-key="1" @change="onChangeTab">
          <a-tab-pane key="1" tab="客户信息">
            <div>
              <a-row :gutter="24">
                <a-col :span="12">
                  <a-form-item label="客户名称">
                    <a-input
                            v-decorator="['custName', { rules: [{ required: true, message: '请输入姓名' }] }]"
                            :disabled="show"
                            placeholder="请输入姓名"
                    />
                  </a-form-item>
                </a-col>
                <a-col :span="12">
                  <a-form-item label="手机号">
                    <a-input
                            v-decorator="['mobile', { rules: [{ required: true, message: '请输入手机号' }] }]"
                            :disabled="show"
                            placeholder="请输入手机号"
                    />
                  </a-form-item>
                </a-col>
              </a-row>
              <a-row :gutter="24">
                <a-col :span="12">
                  <a-form-item label="客户性别">
                    <a-radio-group @change="onChange" :disabled="show"
                                   v-decorator="['sex', { rules: [{ required: true, message: '请选择性别' }] }]">
                      <a-radio :value="1">
                        男
                      </a-radio>
                      <a-radio :value="0">
                        女
                      </a-radio>
                    </a-radio-group>
                  </a-form-item>
                </a-col>
                <a-col :span="12">
                  <a-form-item label="出生日期">
                    <a-date-picker @change="onChangeDate"
                                   v-decorator="['birthday']"
                                   :disabled="show"
                                   value-format="YYYY-MM-DD"
                    />
                  </a-form-item>
                </a-col>
              </a-row>
              <a-row :gutter="24">
                <a-col :span="12">
                  <a-form-item label="民族">
                    <a-select
                            style="width: 250px"
                            v-decorator="['nationId']"
                            :disabled="show"
                            :options="nation"
                            @change="handleChange6"
                    >
                    </a-select>
                  </a-form-item>
                </a-col>
                <a-col :span="12">
                  <a-form-item label="身份证">
                    <a-input
                            v-decorator="['idCard']"
                            :disabled="show"
                            placeholder="请输入身份证"
                    />
                  </a-form-item>
                </a-col>
              </a-row>
              <a-row :gutter="24">
                <a-col :span="12">
                  <a-form-item label="省市区">
                    <a-cascader v-decorator="['mbrAreaList']"
                                placeholder="请选择所在区域"
                                :options="treeData"
                                :fieldNames="{ label: 'areaName', value: 'areaId', children: 'children' }"
                                :disabled="show"
                                @change="handleChange7"
                    />
                  </a-form-item>
                </a-col>
                <a-col :span="12">
                  <a-form-item label="详细地址">
                    <a-input
                            v-decorator="['address']"
                            :disabled="show"
                    />
                  </a-form-item>
                </a-col>
              </a-row>
              <a-row :gutter="24">
                <a-col :span="12">
                  <a-form-item label="客户类型">
                    <a-select
                            v-decorator="['custCategoryId']"
                            style="width: 250px" @change="handleChange" :disabled="show"
                            :options="customerType">
                    </a-select>
                  </a-form-item>
                </a-col>
                <a-col :span="12">
                  <a-form-item label="所属细分行业">
                    <a-select
                            v-decorator="['industryId']"
                            style="width: 250px" :disabled="show" @change="handleChange4"
                            :options="subdividedTradeStructure">
                    </a-select>
                  </a-form-item>
                </a-col>
              </a-row>
              <a-row :gutter="24" style="margin:5px 0 15px 0;font-weight: bold;font-size: 15px">
                保有车辆信息
              </a-row>
              <a-row :gutter="24">
                <a-col :span="12">
                  <a-form-item label="品系">
                    <a-input
                            v-decorator="['strainName']"
                            :disabled="true"
                    />
                  </a-form-item>
                </a-col>
                <a-col :span="12">
                  <a-form-item label="车型代码">
                    <a-input
                            v-decorator="['modelCode']"
                            :disabled="true"
                    />
                  </a-form-item>
                </a-col>
              </a-row>
              <a-row :gutter="24">
                <a-col :span="12">
                  <a-form-item label="底盘号">
                    <a-input
                            v-decorator="['batholithNo']"
                            :disabled="true"
                    />
                  </a-form-item>
                </a-col>
              </a-row>
            </div>
          </a-tab-pane>
          <a-tab-pane key="2" tab="客户历史记录">
            <operationLog :operationLogList="operationLogList"></operationLog>
          </a-tab-pane>
        </a-tabs>





      </a-form>
    </div>

    <a-space class="a-form-btn-box">
      <a-button @click="endEdit('cancelled')">取消</a-button>
      <a-button type="primary" @click="_save(false)">提交</a-button>
    </a-space>
  </a-spin>
</template>

<script>

import {formMixin, fmt} from '@/utils/common/FormBase'
import operationLog from './operationLog.vue'
console.log(fmt)
//通用代码api
import {loadAreaTreeCasData, loadBaseCodeData, dealTreeNoChild} from '@/services/baseCodeSource';


console.log(loadBaseCodeData)

//接口API
import {dataApi} from '@/services/client/maintainCust';


import {mapState} from "vuex";




function begin() {
  this.have = 1
  this.show = false;
}

/**
 * 加载数据之后执行的函数(新建表单也会执行)
 */
function afterLoad(entity) {
  console.log(entity)
  if (entity.provinceId) {
    this.setFormValue({
      'mbrAreaList': [entity.provinceId, entity.cityId, entity.districtId]
    })
  }

}

/**
 * 新建表单数据 没有预设可以不写  预设的值可以在afterLoad之中调用到
 * 一般是用来写表单默认值 或者写不在表单中需要保存的值
 * @returns {Object}
 */
function newEntity() {
  return {}
}

/**
 * 加载数据
 * @param rowId 主键值
 * @returns {Promise}
 */
async function loadEntity(rowId) {
  console.log("初始化数据",rowId)
  let entity = await dataApi.getFormDetail(rowId);
  console.log("初始化数据",entity)
  this.entityForm = entity.data
  this.custName = entity.data.custName
  this.custId = entity.data.custId
  this.mobile = entity.data.mobile
  this.idCard = entity.data.idCard
  this.sex = entity.data.sex
  this.birthday = entity.data.birthday
  this.nationId = entity.data.nationId
  this.industryId = entity.data.industryId
  this.modelCode = entity.data.modelCode
  this.strainName = entity.data.strainName
  this.batholithNo = entity.data.batholithNo
  this.operationLogList = entity.data.operationLogList
  return fmt.formatFormLoad(entity);
}


/**
 * 加载基础数据
 */
async function loadBaseData() {
  this.customerType = await loadBaseCodeData('CD300003'); //客户类型
  this.subdividedTradeStructure = await loadBaseCodeData('CD300005');//所属细分行业
  this.nation = await loadBaseCodeData('CD000002');//民族
  this.treeData = await loadAreaTreeCasData();
  dealTreeNoChild(this.treeData)
}


/**
 * 提交数据
 * @param entities
 * @param vm
 * @returns {Promise}
 */
async function save(entities, vm) {
  console.log("保存2", entities)
  entities.vehicleId = vm.keyId;
  entities.custId = vm.custId;

  if (entities.mbrAreaList) {
    entities.provinceId = entities.mbrAreaList.split(',')[0];
    entities.cityId = entities.mbrAreaList.split(',')[1];
    entities.districtId = entities.mbrAreaList.split(',')[2];
  }
  console.log("保存1", entities)
  return await dataApi.saveFormDetail(entities);
  // return null;
}


/**
 * 表单组件
 */
export default {
  mixins: [formMixin],
  components: {
    operationLog
  },
  computed: {
    ...mapState('account', {currUser: 'user'}),
  },
  data() {
    return {
      treeData: [],
      infoForm: {},
      show: true,
      have: 1,
      has: 1,
      strainOptions: [],
      customerType: [],
      customerProperty: [],
      subdividedTradeStructure: [],
      customerSource: [],
      wantStrainOption: [],
      dealRecordList: {},
      followRecordList: {},
      operationLogList: [],
      customerTrailList: [],
      vehicleOwnershipList: [],
      entityForm: {},
      imgList: [],
      nation: [],
      custCategoryId: 0,
      sourceId: 0,
      sourceName: '',// 客户来源

      custCategoryName: '',// 客户类型
      custNatureName: '',// 客户性质
      industryName: '',// 细分行业
      learnTypeName: '',// 了解柳汽方式
      loyalDimensionName: '',// 忠诚维度
      nationName: '',// 民族
      provinceName: '',
      cityName: '',
      districtName: '',
      strainName: '',// 意向品系
    }
  },
  filters: {
  },
  mounted() {
    this.begin();
  },
  methods: {
    begin,
    loadEntity,
    newEntity,
    save,
    loadBaseData,
    afterLoad,
    handleChange7(value) {
      console.log(value);
      this.treeData.map(item => {
        console.log(item);
        console.log('value', value);
        if (item.areaId === value[0]) {
          this.provinceName = item.areaName
          console.log('这是name')
          console.log(this.provinceName);
          item.children.map(item => {
            if (item.areaId === value[1]) {
              this.cityName = item.areaName
              console.log('这是name')
              console.log(this.cityName);
              item.children.map(item => {
                if (item.areaId === value[2]) {
                  this.districtName = item.areaName
                  console.log('这是name')
                  console.log(this.districtName);
                }
              })
            }
          })
        }
      })
      this.mbrAreaList = value
    },

    handleChange6(value) {
      console.log(value)
      this.nation.map(item => {
        console.log(item);
        if (item.codeId === value) {
          this.nationName = item.codeName
          console.log(this.nationName)

        }
      })
      this.nationId = value
    },

    handleChange4(value) {
      console.log(value);
      this.subdividedTradeStructure.map(item => {
        console.log(item);
        if (item.codeId === value) {
          this.industryName = item.codeName
          console.log(this.industryName)

        }
      })
      this.industryId = value
    },
    handleChange(value) {
      console.log(value);
      this.customerType.map(item => {
        console.log(item);
        if (item.codeId === value) {
          this.custCategoryName = item.codeName
          console.log(this.custCategoryName)

        }
      })
      this.custCategoryId = value
    },
    onChange(e) {
      console.log('radio checked', e.target.value);
    },
    handleSubmit(e) {
      console.log(e)
    },
    fold() {
      this.have = (this.have == 1) ? 2 : 1
    },
    onChangeDate(date, dateString) {
      console.log(date, dateString);
      this.birthday = dateString
      console.log("生日",this.birthday)
    },
    onChangeTab(val){
      console.log("onChangeTab", val);
    }
  },
};
</script>

<style scoped lang="less">
.nav_info_box {
  display: flex;
  justify-content: space-around;
  border-top: 1px solid #e1e1e1;
  border-bottom: 1px solid #e1e1e1;
  padding: 18px 0;

  .info_item {
    display: flex;
    flex-direction: column;
    justify-content: flex-start;

    .name {
      color: #333;
      font-size: 18px;
      text-align: center;
      font-weight: bold;
    }

    .value {
      color: #999;
      font-size: 16px;
      text-align: center;
      height: 30px;
      line-height: 36px;

      &.more {
        display: flex;
        justify-content: space-around;
      }

      .header {
        width: 30px;
        height: 30px;
        margin: 0 3px;
        border: 1px solid #e1e1e1;
      }
    }
  }
}


/deep/ .ant-modal-content > .ant-modal-body {
  padding: 0 !important;
}

/deep/ .ant-modal {
  width: 1040px !important;
}

.big_box {
  padding: 26px 0;
}

.left_small_box {
  width: 52px;
  height: 52px;
  border-radius: 50%;
  overflow: hidden;

  img {
    width: 100%;
    height: 100%;
    object-fit: contain;
  }
}

.left_box {
  width: 90%;
}

.right_box {
  line-height: 32px;
  margin-top: 18px;
}

.wechat {
  margin: 0 20px;
}

.right_small_box {
  width: 80%;
  height: 55px;
  padding-left: 10px;
}

.btn_box {
  width: 80%;
  height: 50%;
}

.a_btn_box {
  height: 24px;
  border-radius: 5px;
  padding: 0 5px;
  margin-right: 5px;
}

.word_box p {
  margin-top: 0;
}

.img_box_one {
  width: 27px !important;
}

.img_box {
  width: 14px;
  height: 27px;
  overflow: hidden;

  img {
    width: 27px;
    height: 27px;
  }
}

.sel_box {
  margin-top: 15px;
  padding-bottom: 30px;
  border-bottom: 1px solid #ccc;
}

.color_box {
  color: #6f718a;
  font-weight: 800;
}

.content_box {
  height: 50px;
  display: flex;
  justify-content: space-around;
  align-items: center;
  border-bottom: 1px solid #e1e1e1;

  .content_small_box {
    font-size: 18px;
    line-height: 46px;
    cursor: pointer;
    font-weight: bold;

    &.active {
      color: #009cff;
      border-bottom: 3px solid #009cff;
    }
  }
}

.info_box {
  border-bottom: 1px solid #ccc;
  padding-left: 5px;
  font-size: 15px;
  font-weight: bold;
  height: 60px;
  line-height: 60px;
  cursor: pointer;
  margin-bottom: 8px;
}

.num_box {
  color: #009cff;
  font-weight: 600;
}

/deep/ .ant-collapse {
  border: none;
}

/deep/ .ant-collapse > .ant-collapse-item {
  border: none;
}

/deep/ .ant-collapse > .ant-collapse-item > .ant-collapse-header {
  background-color: #fff;
}

/deep/ .ant-collapse-content > .ant-collapse-content-box {
  padding: 10px;
}

/deep/ .ant-form {
  padding: 0;
}

/deep/ .ant-col-5 {
  text-align: left;
  text-overflow: ellipsis; /* 加上，显示省略号*/
  white-space: nowrap;
  overflow: hidden;
  z-index: 100;

}

/deep/ .ant-col-5:hover {
  /* 鼠标滑过  显示隐藏的内容  伴有横向的滚动条 */
  //overflow: auto;
  text-overflow: clip;
}

/deep/ .ant-input {
  width: 250px;
  padding-left: 15px !important;
}

.two_box {
  padding: 15px;
}

.transaction {
  padding: 8px 0 4px 12px;
  background-color: #f6f6f6;
}

.transaction_word {
  margin-bottom: 6px;
}

.follow_up_box {
  padding: 0 15px;
}

.follow_up_word {
  margin-bottom: 8px;
}

.follow_up_img {
  width: 52px;
  height: 52px;
  border-radius: 50%;
  border: 1px solid #e1e1e1;
  margin-right: 10px;
}

.follow_up_name {
  margin: 6px 0 1px 0;
  font-weight: 800;
}

.follow_up_small_box {
  border-bottom: 1px solid #cccccc;
  padding: 12px 0 26px 0;
}

/deep/ .ant-input[disabled] {
  background-color: #fff !important;
  pointer-events: none;
}

.a_input {
  border: none;
}

/deep/ .ant-select-disabled .ant-select-selection {
  background-color: #fff;
  pointer-events: none;
}

/deep/ .ant-calendar-picker-icon {
  right: -102px !important;
}

.ant-calendar-picker-clear > .ant-calendar-picker-icon {
  right: -95px !important;
}

/deep/ .ant-form-item {
  margin-bottom: 9px;
}

/deep/ .ant-cascader-picker-arrow {
  right: -101px !important;
}

/deep/ .ant-cascader-picker-label {
  width: 200px;
}

/deep/ .ant-cascader-picker-clear {
  right: -80px !important;
}

/deep/ .ant-form-item .ant-form-explain {
  bottom: -15px !important;
}

/deep/ .ant-popover-inner-content {
  padding: 0 !important;
  display: none;
}

</style>
